var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M23.1813 15.4832C21.3213 21.8506 15.3612 24.5504 9.86839 23.0808C4.37556 21.6113 1.15436 15.8306 2.67363 10.1693C4.19291 4.50794 9.87735 1.10984 15.3702 2.57938C20.863 4.04892 24.5099 8.05461 23.1813 15.4832Z",
  fill: "url(#paint0_linear_35176_33998)"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.6301 15.6627C22.021 21.6585 15.9862 25.291 10.12 23.7215C4.2537 22.1521 0.846429 15.9935 2.45548 9.99766C4.06452 4.00183 10.0994 0.369328 15.9656 1.93877C21.8319 3.50822 25.2391 9.66684 23.6301 15.6627ZM10.2919 23.0809C15.7847 24.5504 21.4692 21.1523 22.9884 15.491C24.5077 9.82968 21.2865 4.04898 15.7937 2.57944C10.3008 1.1099 4.61641 4.50801 3.09713 10.1693C1.57785 15.8306 4.79906 21.6113 10.2919 23.0809Z",
  fill: "url(#paint1_linear_35176_33998)"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M21.9002 14.8292C20.3809 20.4905 14.6965 23.8886 9.20363 22.4191C3.7108 20.9496 0.489593 15.1689 2.00887 9.50755C3.52815 3.84624 9.21259 0.448133 14.7054 1.91767C20.1983 3.38721 23.4195 9.16791 21.9002 14.8292Z",
  fill: "url(#paint2_linear_35176_33998)"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5423 15.0007C20.9333 20.9965 14.8984 24.6291 9.03218 23.0596C3.16592 21.4902 -0.241345 15.3315 1.3677 9.33572C2.97675 3.3399 9.01158 -0.292606 14.8778 1.27684C20.7441 2.84628 24.1514 9.00491 22.5423 15.0007ZM9.20411 22.4189C14.6969 23.8885 20.3814 20.4904 21.9007 14.8291C23.4199 9.16775 20.1987 3.38705 14.7059 1.91751C9.21307 0.44797 3.52863 3.84608 2.00936 9.50739C0.490078 15.1687 3.71128 20.9494 9.20411 22.4189Z",
  fill: "url(#paint3_linear_35176_33998)"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5423 15.0007C20.9333 20.9965 14.8984 24.6291 9.03218 23.0596C3.16592 21.4902 -0.241345 15.3315 1.3677 9.33572C2.97675 3.3399 9.01158 -0.292606 14.8778 1.27684C20.7441 2.84628 24.1514 9.00491 22.5423 15.0007ZM9.20411 22.4189C14.6969 23.8885 20.3814 20.4904 21.9007 14.8291C23.4199 9.16775 20.1987 3.38705 14.7059 1.91751C9.21307 0.44797 3.52863 3.84608 2.00936 9.50739C0.490078 15.1687 3.71128 20.9494 9.20411 22.4189Z",
  fill: "black",
  fillOpacity: 0.1
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M19.9752 14.3137C18.7408 18.9136 14.1491 21.6817 9.71943 20.4966C5.28973 19.3115 2.69943 14.6219 3.93384 10.0221C5.16826 5.42225 9.75993 2.65408 14.1896 3.8392C18.6193 5.02431 21.2096 9.71392 19.9752 14.3137Z",
  fill: "url(#paint4_radial_35176_33998)"
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.6169 14.4862C19.2939 19.4159 14.3551 22.4243 9.5475 21.1381C4.73993 19.8519 1.96924 14.7809 3.29219 9.85121C4.61514 4.92148 9.554 1.91313 14.3616 3.19934C19.1691 4.48554 21.9398 9.55648 20.6169 14.4862ZM9.71943 20.4974C14.1491 21.6825 18.7408 18.9144 19.9752 14.3145C21.2096 9.71473 18.6193 5.02512 14.1896 3.84001C9.75993 2.6549 5.16825 5.42306 3.93384 10.0229C2.69943 14.6227 5.28972 19.3123 9.71943 20.4974Z",
  fill: "url(#paint5_linear_35176_33998)"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.6169 14.4862C19.2939 19.4159 14.3551 22.4243 9.5475 21.1381C4.73993 19.8519 1.96924 14.7809 3.29219 9.85121C4.61514 4.92148 9.554 1.91313 14.3616 3.19934C19.1691 4.48554 21.9398 9.55648 20.6169 14.4862ZM9.71943 20.4974C14.1491 21.6825 18.7408 18.9144 19.9752 14.3145C21.2096 9.71473 18.6193 5.02512 14.1896 3.84001C9.75993 2.6549 5.16825 5.42306 3.93384 10.0229C2.69943 14.6227 5.28972 19.3123 9.71943 20.4974Z",
  fill: "#1A5F46",
  fillOpacity: 0.7
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.1208 6.26295C17.2083 5.45093 16.1045 4.83726 14.8543 4.50277C10.4246 3.31766 5.83289 6.08582 4.59847 10.6856C3.80191 13.6539 4.59799 16.6595 6.45323 18.7367C4.13256 16.6717 3.04818 13.3239 3.93418 10.0224C5.1686 5.42255 9.76027 2.65439 14.19 3.8395C15.7612 4.25986 17.101 5.12115 18.1208 6.26295Z",
  fill: "url(#paint6_linear_35176_33998)"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.1208 6.26295C17.2083 5.45093 16.1045 4.83726 14.8543 4.50277C10.4246 3.31766 5.83289 6.08582 4.59847 10.6856C3.80191 13.6539 4.59799 16.6595 6.45323 18.7367C4.13256 16.6717 3.04818 13.3239 3.93418 10.0224C5.1686 5.42255 9.76027 2.65439 14.19 3.8395C15.7612 4.25986 17.101 5.12115 18.1208 6.26295Z",
  fill: "#1A5F46",
  fillOpacity: 0.7
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.83457 8.99651C2.66273 8.93239 2.57549 8.74134 2.6397 8.56977C3.78617 5.50643 6.35362 3.13566 9.54229 2.25694C9.71912 2.20822 9.90203 2.31184 9.95084 2.48839C9.99964 2.66495 9.89586 2.84758 9.71903 2.89631C6.73721 3.71803 4.33445 5.93628 3.26196 8.80194C3.19775 8.97351 3.0064 9.06062 2.83457 8.99651Z",
  fill: "#82EDBA",
  fillOpacity: 0.7
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2308 17.1939C20.3859 17.2917 20.4322 17.4965 20.3343 17.6514C19.5573 18.8794 18.5271 19.9317 17.3169 20.7351C17.1641 20.8365 16.9579 20.7951 16.8564 20.6426C16.7548 20.4901 16.7963 20.2842 16.9491 20.1828C18.0816 19.431 19.0457 18.4462 19.7726 17.2971C19.8706 17.1423 20.0757 17.0961 20.2308 17.1939Z",
  fill: "#8AEAB1",
  fillOpacity: 0.7
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.49258 4.48526C6.49251 4.48531 6.49265 4.48522 6.49258 4.48526L6.30834 4.20933C6.49258 4.48526 6.49253 4.48529 6.49258 4.48526L6.49138 4.48607L6.48465 4.49064C6.47836 4.49494 6.46855 4.50171 6.45552 4.51087C6.42947 4.5292 6.39062 4.55707 6.34155 4.59381C6.2433 4.66739 6.10462 4.77615 5.9458 4.9149C5.62631 5.19403 5.23418 5.58685 4.92397 6.05146C4.82222 6.20385 4.616 6.24503 4.46337 6.14344C4.31074 6.04184 4.2695 5.83594 4.37125 5.68354C4.72533 5.15324 5.16356 4.71698 5.50836 4.41574C5.68169 4.26432 5.83363 4.14508 5.94298 4.0632C5.9977 4.02222 6.04189 3.99049 6.07292 3.96866C6.08844 3.95774 6.10069 3.94929 6.10932 3.94339L6.11953 3.93645L6.12253 3.93443L6.1235 3.93379C6.12356 3.93375 6.1241 3.93339 6.30834 4.20933L6.1235 3.93379C6.27613 3.83219 6.48294 3.87297 6.5847 4.02537C6.68641 4.1777 6.64504 4.38362 6.49258 4.48526Z",
  fill: "#9DF9C2"
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M15.2039 10.1318L13.966 9.87431C14.0972 10.1995 14.1494 10.5599 14.1228 10.9555L15.2699 11.194L14.7606 12.1724L13.9031 11.9941C13.6836 12.6038 13.3293 13.0326 12.8403 13.2803C12.3521 13.5244 11.7204 13.5996 10.9455 13.5059L12.9168 17.1628L12.9007 17.2369L11.271 16.898L9.11503 12.9167L9.29881 12.0434L10.7354 12.3422C11.1594 12.4303 11.5135 12.4126 11.7975 12.2889C12.0861 12.1624 12.3035 11.9633 12.4494 11.6918L9.39452 11.0564L9.9095 10.0792L12.6521 10.6496C12.5946 10.022 12.157 9.6232 11.3393 9.45316L9.81183 9.13549L10.3711 8.03643L15.7201 9.14886L15.2039 10.1318Z",
  fill: "#017654"
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2672 10.6535C15.4363 10.6319 15.5897 10.5295 15.6722 10.3722L16.1884 9.38933C16.2652 9.24303 16.2693 9.06991 16.1995 8.92135C16.1296 8.77279 15.9939 8.66586 15.8325 8.63229L10.4835 7.51986C10.2488 7.47105 10.0092 7.58627 9.90029 7.80041L9.34104 8.89948C9.26665 9.04567 9.26426 9.21743 9.33456 9.36445C9.39481 9.49046 9.50262 9.58607 9.63308 9.6318C9.55425 9.68067 9.4876 9.75032 9.4422 9.83648L8.92722 10.8137C8.85012 10.96 8.84582 11.1333 8.91562 11.282C8.96811 11.3938 9.05794 11.4821 9.16795 11.5333C9.11297 11.5478 9.06011 11.5711 9.01159 11.6028C8.89343 11.6801 8.8107 11.8009 8.78176 11.9385L8.59797 12.8118C8.57235 12.9335 8.59065 13.0601 8.64964 13.169L10.8056 17.1503C10.8789 17.2855 11.0081 17.3815 11.1593 17.4129L12.789 17.7519C13.0743 17.8112 13.3558 17.6284 13.4177 17.3436L13.4338 17.2694C13.4604 17.147 13.4425 17.0195 13.3833 16.9097L11.8479 14.0614C12.2975 14.032 12.7095 13.9325 13.0746 13.7501L13.0772 13.7488C13.576 13.496 13.9518 13.1016 14.2141 12.597L14.6489 12.6874C14.8818 12.7358 15.1197 12.6227 15.2298 12.4112L15.7391 11.4328C15.8152 11.2865 15.8189 11.1138 15.7489 10.9657C15.6789 10.8175 15.5433 10.711 15.3823 10.6775L15.2672 10.6535ZM13.9034 11.9933L14.7609 12.1716L15.2702 11.1932L14.1232 10.9547C14.1351 10.7769 14.1311 10.6062 14.1112 10.4427C14.0869 10.2423 14.0386 10.0526 13.9663 9.8735L15.2042 10.131L15.7204 9.14805L10.3714 8.03562L9.81217 9.13468L11.3396 9.45235C11.8672 9.56206 12.2365 9.767 12.4477 10.0672C12.5638 10.2322 12.6321 10.4261 12.6525 10.6488L9.90984 10.0784L9.39486 11.0556L12.4498 11.691C12.3498 11.8769 12.2164 12.0288 12.0496 12.1468C11.9728 12.2011 11.8888 12.2482 11.7978 12.2881C11.5138 12.4118 11.1598 12.4295 10.7358 12.3414L9.29918 12.0426L9.11537 12.9159L11.2714 16.8972L12.901 17.2361L12.9171 17.162L10.9459 13.5051C11.1651 13.5316 11.3728 13.5446 11.569 13.5441C12.0666 13.5427 12.4905 13.4545 12.8406 13.2795C13.3297 13.0318 13.684 12.603 13.9034 11.9933Z",
  fill: "#017654"
});

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M14.8654 9.87439L13.6286 9.61189C13.7584 9.9376 13.8092 10.2982 13.781 10.6937L14.9271 10.9369L14.4138 11.9132L13.557 11.7314C13.3351 12.3402 12.979 12.7675 12.489 13.0133C11.9997 13.2553 11.3678 13.3279 10.5933 13.2312L12.5496 16.896L12.5332 16.9701L10.9049 16.6245L8.76522 12.6345L8.95257 11.7619L10.388 12.0665C10.8116 12.1564 11.1657 12.1402 11.4502 12.0177C11.7394 11.8923 11.9575 11.6941 12.1046 11.4232L9.05232 10.7754L9.57129 9.80027L12.3116 10.3818C12.2566 9.75402 11.8206 9.35341 11.0037 9.18003L9.47749 8.85613L10.0412 7.75936L15.3856 8.8936L14.8654 9.87439Z",
  fill: "white"
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.2085 10.0531C15.1267 10.2074 14.952 10.2892 14.7816 10.253L14.1553 10.1201C14.1658 10.2059 14.1724 10.2929 14.1753 10.3811L15.0109 10.5584C15.1291 10.5835 15.2284 10.6622 15.2794 10.7713C15.3303 10.8803 15.3272 11.0072 15.2708 11.1144L14.7575 12.0907C14.676 12.2458 14.5008 12.3281 14.3299 12.2919L13.789 12.1771C13.5346 12.7047 13.1615 13.1079 12.6613 13.3588L12.6594 13.3597C12.2554 13.5596 11.7864 13.6544 11.2633 13.6595L12.8928 16.7122C12.9359 16.793 12.9487 16.8867 12.9288 16.9766L12.9124 17.0506C12.8661 17.2597 12.6587 17.3932 12.4493 17.3487L10.821 17.0031C10.71 16.9796 10.6154 16.9087 10.562 16.8091L8.42229 12.8191C8.37928 12.7389 8.36622 12.6459 8.38541 12.5565L8.57276 11.684C8.59444 11.583 8.65558 11.4945 8.74262 11.4381C8.82965 11.3816 8.9354 11.362 9.03641 11.3834L10.4718 11.688C10.8472 11.7677 11.1126 11.7426 11.2982 11.6628C11.3055 11.6596 11.3128 11.6564 11.32 11.6531L8.96843 11.154C8.84986 11.1288 8.75038 11.0498 8.69955 10.9403C8.64872 10.8308 8.65239 10.7035 8.70948 10.5963L9.22845 9.62119C9.31041 9.46719 9.48488 9.38565 9.65513 9.42178L11.6057 9.83575C11.4537 9.72261 11.2323 9.62498 10.9198 9.55865L9.39361 9.23475C9.276 9.20979 9.17711 9.13178 9.1259 9.02356C9.0747 8.91534 9.07697 8.78917 9.13206 8.68199L9.6958 7.58522C9.77649 7.42823 9.9528 7.3443 10.1251 7.38086L15.4695 8.5151C15.5879 8.54025 15.6874 8.61921 15.7382 8.72856C15.7891 8.8379 15.7856 8.96507 15.7287 9.07232L15.2085 10.0531ZM12.2031 9.96253C12.262 10.0888 12.2981 10.2286 12.3115 10.3819L9.57127 9.80034L9.0523 10.7754L12.1046 11.4232C12.0338 11.5537 11.9465 11.6673 11.8427 11.764C11.731 11.8681 11.6001 11.9527 11.4502 12.0177C11.1657 12.1403 10.8116 12.1565 10.3879 12.0666L8.95255 11.762L8.7652 12.6345L10.9049 16.6246L12.5331 16.9701L12.5496 16.8961L10.5933 13.2312C10.7533 13.2512 10.9073 13.264 11.0551 13.2695C11.6228 13.2908 12.1008 13.2054 12.4889 13.0134C12.979 12.7676 13.335 12.3403 13.557 11.7315L14.4137 11.9133L14.927 10.937L13.781 10.6938C13.7975 10.4618 13.7869 10.2418 13.7491 10.0339C13.7224 9.88728 13.6823 9.74663 13.6285 9.61195L14.8654 9.87445L15.3856 8.89366L10.0412 7.75942L9.47747 8.85619L11.0036 9.18009C11.621 9.31112 12.0209 9.57194 12.2031 9.96253Z",
  fill: "#017654"
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_35176_33998",
  x1: 23.8216,
  y1: 19.3966,
  x2: 4.32517,
  y2: 3.28733,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#337461"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8AD1BC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_35176_33998",
  x1: 23.8216,
  y1: 19.3966,
  x2: 4.32517,
  y2: 3.28733,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#337461"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8AD1BC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_35176_33998",
  x1: 25.7736,
  y1: 24.757,
  x2: 0.43786,
  y2: -2.08158,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#539984"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#20E3AA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_35176_33998",
  x1: 25.7738,
  y1: 25.7314,
  x2: 4.82345,
  y2: 3.28489,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52AD92"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#14AE81"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_35176_33998",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.3221 11.6416) rotate(-109.676) scale(10.0638 9.9438)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#53E7BA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4CAD91"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_35176_33998",
  x1: 14.9375,
  y1: 21.811,
  x2: 6.93065,
  y2: 1.6596,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#489F85"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#63CBAC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_35176_33998",
  x1: 15.2219,
  y1: 18.1299,
  x2: 4.61035,
  y2: 4.02471,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#489F85"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#63CBAC"
})));

var SvgIconCash = function SvgIconCash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-cash.393784a2.svg";
export { ForwardRef as ReactComponent };